import styled from 'styled-components';
import { themeGet } from 'styled-system';

const SectionWrapper = styled.section`
  background-color: #f2f2f2;
  padding: 80px 0;
  overflow: hidden;
  @media (max-width: 990px) {
    padding: 60px 0 30px 0;
  }
  @media (max-width: 767px) {
    padding: 40px 0 30px 0;
  }
  .subtitle {
    max-width: 817px;
    margin-top: 15px;
    margin-left: auto;
    margin-right: auto;
    text-align: left;
  }
`;

export const BoxWrapper = styled.div`
.row {
  display: flex;
}
.card {
  padding: 20px;
  margin-left: 25px;
  margin-bottom: 27px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  @media (max-width: 767px) {
    width: calc(50% - 13px);
    &:nth-child(2n + 1) {
      margin-left: 0;
    }
  }
`;

export default SectionWrapper;
